module.exports = __webpack_public_path__ + "static/media/ja-JP.86aad40a.md";